import { TipoAutorizacaoPortariaEnum } from "core/features/portaria/enums";
import { useState } from "react";
import moment from "moment";
import { PaginateQuery } from "core/resources/types/shared";

export interface ListagemAutorizacaoPortariaFiltro extends PaginateQuery {
  search: string;
  dataInicio: string;
  dataFim: string;
  tipoAutorizacaoId: TipoAutorizacaoPortariaEnum | null;
  unidadeId?: string;
  pessoaId?: string;
  verConfirmadas?: "1" | "0";
}
export const filtroDefaultPortaria: ListagemAutorizacaoPortariaFiltro = {
  search: "",
  dataInicio: moment().subtract(1, "days").format("YYYY-MM-DD"),
  dataFim: moment().format("YYYY-MM-DD"),
  tipoAutorizacaoId: null,
  unidadeId: undefined,
  pessoaId: undefined,
  limit: 50,
};

function useFiltro() {
  const [filtro, setFiltro] = useState<ListagemAutorizacaoPortariaFiltro>(
    filtroDefaultPortaria
  );

  const onChangeFiltro = (
    filtro: Partial<ListagemAutorizacaoPortariaFiltro>
  ) => {
    setFiltro((state) => ({ ...state, ...filtro }));
  };

  return {
    filtro,
    onChangeFiltro,
  };
}

export default useFiltro;
